
export class ExploreNavigationModule {
    static get FleetHistory(): string { return 'app.explore.fleethistory'; }
    static get FleetUtilisation(): string { return 'app.explore.fleetutilisation'; }
    static get FleetEvents(): string { return 'app.explore.fleetevents'; }
    static get FindNearest(): string { return 'app.explore.findnearest'; }
    static get DepotCompliance(): string { return 'app.explore.depotcompliance'; }
    static get DriverBehaviour(): string { return 'app.explore.driverbehaviour'; }

    static get Default(): string { return this.FleetHistory; }
    static get ParentRoot(): string { return "app.explore"; }
}
